declare global {
  interface Window {
    pushToDataLayer: any
    dataLayer: any
  }
}

export function PushToDataLayer(event: object) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}

/**
 * gtag tracking event.
 * @param eventName event name.
 * @param params an object of the event parameters.
 */
export const TrackEvent = (eventName: string, params: object) => {
  const trackingEventData = { event: eventName, value: params }
  if (window.pushToDataLayer) {
    window.pushToDataLayer(trackingEventData)
  } else {
    PushToDataLayer(trackingEventData)
  }
}
